export default __webpack_public_path__ + "static/media/autonome.00954286.png";